export default "__VITE_ASSET__CIjF3xwY__"